module.exports = __webpack_public_path__ + "static/media/onlineshop.dfbe42c5.mp4";